<template>
  <div class="form" v-if="isPromptActiveLocal ? true : false">
    <p class="form_title">Valider l'OTP</p>
    <p class="form_subtitle">
      <span class="yello_word">Y’ello</span>, veuillez fournir le code envoyé au
      <small class="agent_number">{{ cryptNumber(this.phone) }}</small>
    </p>
    <div class="form_field">
      <!-- <vs-input class="w-full" label="Code" /> -->
      <p class="font-bold text-black">Code</p>
      <!-- <vie-otp-input
        ref="otpInput"
        inputClasses="otp-input"
        :numInputs="6"
        separator=""
        :shouldAutoFocus="true"
        @on-complete="handleOnComplete"
      /> -->
      <input type="text" class="digit-box" v-for="(el, ind) in digitCount" :key="el + ind" v-model="digits[ind]"
        :autofocus="ind === 0" maxlength="1" :ref="'input'" @keydown="handleKeyDown($event, ind)" />

      <span v-if="!!formErrors.code">
        <div class="
            con-text-validation
            span-text-validation-danger
            vs-input--text-validation-span
            v-enter-to
          " style="height: 19px">
          <span class="span-text-validation">
            {{ formErrors.code ? formErrors.code[0] : "" }}
          </span>
        </div>
      </span>
      <vue-recaptcha class="mt-2" ref="recaptcha" :sitekey="captcha_site_key" :loadRecaptchaScript="true" @verify="onCaptchaVerified"
        @expired="onCaptchaExpired">
      </vue-recaptcha>
      <small class="text-danger" v-if="!!formErrors.recaptcha">{{ formErrors.recaptcha ? formErrors.recaptcha[0] : '' }}</small>
      <p class="mt-2">
        <vue-countdown v-if="counting" :auto-start="true" :time="time_before_asking_new_otp" @end="onCountdownEnd">
          <template slot-scope="props">
            <div id="heure" class="heure">
              <span class="link_resend_otp">Renvoyer le code({{ props.minutes }} :
                {{ props.seconds }} )</span>
            </div>
          </template>
        </vue-countdown>
        <span v-if="!counting" class="link_resend_otp" @click="askForNewOtp()">Renvoyer le code</span>
      </p>
    </div>
    <vs-button color="#ffcc00" class="action_button text-dark" @click="validateOTP()">Se connecter</vs-button>

    <p class="link_auth mt-5 ml-2" @click="toggleRegisterPrompt()">
      S'inscrire
    </p>
  </div>
</template>

<script>
import Vue from "vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
Vue.component(VueCountdown.name, VueCountdown);
import VieOtpInput from "@bachdgvn/vue-otp-input";
import { __cryptNumber } from "../../../../helpers/buildquery";
Vue.component("vie-otp-input", VieOtpInput);
import { VueRecaptcha } from 'vue-recaptcha';


export default {
  name: "LoginOtp",
  components: {
    "vie-otp-input": VieOtpInput,
    "vue-countdown": VueCountdown,
    "vue-recaptcha": VueRecaptcha,
  },
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {},
  },
  data() {
    return {
      diviser: 5,
      time_spent: 0,
      counting: false,
      otp: "",
      time_before_asking_new_otp: 0.5 * 60 * 1000,
      formErrors: {},
      digits: ["-", "-", "-", "-", "-", "-"],
      digitCount: 6,
      captcha_site_key: "6LdHwL4kAAAAAA_hS1GW2CIrLlO7YoHMRa71katP",
      recaptcha: "",
      validateCaptcha: false
    };
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          this.startCountdown();
          this.formErrors = {};
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    onCaptchaVerified(recaptchaToken) {
      this.recaptcha = recaptchaToken
      this.validateCaptcha = true
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
      // this.$refs.otpInput.clearInput();
    },
    isDigitsFull() {
      for (const elem of this.digits) {
        if (elem == null || elem == undefined) {
          return false;
        }
      }
      return true;
    },
    handleKeyDown(event, index) {
      if (event.key !== "Tab") {
        event.preventDefault();
      }

      if (event.key === "Backspace") {
        this.$refs.input[index].value = null;
        this.digits[index] = null;

        // if (index != 0) {
        //   let position = index - 1;
        //   this.$refs.input[position].focus();
        // }

        return;
      }
      if (event.key === "ArrowLeft") {
        if (index != 0) {
          let position = index - 1;
          this.$refs.input[position].focus();
        }

        return;
      }
      if (event.key === "ArrowRight") {
        if (index + 1 <= this.digitCount - 1) {
          let position = index + 1;
          this.$refs.input[position].focus();
        }

        return;
      }

      if (
        event.key.length == 1 &&
        new RegExp("^[a-zA-Z0-9]*$").test(event.key)
      ) {
        this.$refs.input[index].value = event.key.toLowerCase();
        this.digits[index] = event.key.toLowerCase();

        if (index != this.digitCount - 1) {
          let position = index + 1;
          this.$refs.input[position].focus();
        } else {
          if (this.isDigitsFull() && this.digits.length == this.digitCount) {
            this.otp = this.digits.join("");
            this.validateOTP();
          }
        }
      }
    },
    cryptNumber(number) {
      return __cryptNumber(number);
    },
    toggleRegisterPrompt() {
      this.$emit("toggleRegisterFormPrompt");
    },
    async validateOTP() {
      this.$vs.loading();
      try {
        let payload = {
          email: this.phone,
          code: this.otp,
          recaptcha: this.recaptcha,
          // origin: 'web'
        };
        let response = await this.$store.dispatch("auth/loginAAJWT", payload);
        this.$vs.loading.close();
        if (response) {
          this.onCaptchaExpired();
          this.$vs.notify({
            title: "Succès",
            text: "Opération effectuée avec succès",
            iconPack: "feather",
            icon: "icon-check",
            color: "success",
            position: "top-right",
          });
          // console.log(response.data.user.firstly);
          if (response.data.user.has_ended_pack_debutant == "1") {
            if (response.data.user.has_ended_register_process == "1") {
              // console.log(44);
              this.$router.push("/aa/formations");
            } else this.$router.push("/aa/evaluation-results/success");
          } else {
            if (response.data.user.aa_firstly == "1") {
              this.$router.push(
                "/aa/formation/packs/follow-begining-pack/" + response.data.pack
              );
            } else {
              this.$router.push("/aa/formations");
            }
          }

          localStorage.removeItem("auth_step");
        }
      } catch (error) {
        this.$vs.loading.close();
        // this.startCountdown();
        if (error.response.status == 422) {
          this.formErrors = error.response.data.errors;
        } else {
          this.formErrors = {};
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
    handleCountdownProgress(data) {
      // this.$refs.otpInput.clearInput();
    },
    // askForNewOtp() {
    //   if (this.counting == true) {
    //     this.$vs.notify({
    //       title: "Succès",
    //       text: "Opération effectuée avec succès",
    //       color: "success",
    //       iconPack: "feather",
    //       icon: "icon-check",
    //       position: "top-right",
    //     });
    //     this.$refs.otpInput.clearInput();
    //     this.otp = "";
    //     this.time_before_asking_new_otp = 0.2 * 60 * 1000;
    //     this.counting = false;
    //   } else {
    //     this.$vs.notify({
    //       title: "Alert",
    //       text: "Veuillez attendre la fin du compte à rebours",
    //       color: "danger",
    //       iconPack: "feather",
    //       icon: "icon-check",
    //       position: "top-right",
    //     });
    //   }
    // },
    async askForNewOtp() {
      this.$vs.loading();
      let payload = { email: this.email, origin: "web" };
      try {
        let response = await this.$http.post("auth/ask-for-otp", payload);
        if (response) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Succès",
            text: "Opération effectuée avec succès",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          // this.$refs.otpInput.clearInput();
          this.digits = ["-", "-", "-", "-", "-", "-"];
          this.otp = "";
          this.startCountdown();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status == 422) {
          this.formErrors = error.response.data.errors;
        } else {
          this.formErrors = {};
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
    handleOnComplete(value) {
      this.otp = value;
      this.validateOTP();
    },
  },
};
</script>

<style lang="scss">
.form {
  width: 38% !important;
  margin-top: 2.5%;
  // border-radius: 0px 30px 30px 30px;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin-right: 0.6rem;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: "center";
}

.otp-input.error {
  border: 1px solid red !important;
}

.digit-box {
  height: 34px;
  width: 32px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  margin-right: 5px;
  font-size: 17px;
  text-align: center;
  color: #b9b9c3;
}

.digit-box:focus {
  outline: 2px solid rgba(0, 0, 0, 0.3);
}

@media (max-width: 1098px) {
  .digit-box {
    height: 30px;
    width: 28px;
  }
}
</style>